module.exports = __webpack_public_path__ + "img/image.22556fbc.svg";